import React, { useEffect, useState } from "react";
import { TextHeader } from "components/Texts";
import { useDispatch, useSelector } from "react-redux";
import Button from "components/Buttons";

import Row from "components/Row";
import Section from "components/Section";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import googleActions from "modules/google/actions";
import googleSelectors from "modules/google/selectors";

const Connected = () => {
  const { REACT_APP_RMP_APP_ID } = process.env;
  const dispatch = useDispatch();
  const rmpToken = sessionStorage.getItem("rmp_token");
  const [loading] = useState(false);
  const accountDataResult = useSelector((state) => googleSelectors.getAccountDataResult(state));
  const businessInfoResult = useSelector((state) => googleSelectors.getBusinessInfoResult(state));
  const setBusinessAdwordsIdResult = useSelector((state) => googleSelectors.setBusinessAdwordsIdResult(state));

  //eslint-disable-next-line no-unused-vars
  const [t, i18n] = useTranslation();

  useEffect(() => {
    if (
      !businessInfoResult.data.adwords_id ||
      businessInfoResult.data.adwords_id === "" ||
      (setBusinessAdwordsIdResult.adwordsId &&
        setBusinessAdwordsIdResult.adwordsId !== businessInfoResult.data.adwords_id)
    ) {
      dispatch(
        googleActions.getBusinessInfo(rmpToken, {
          appId: REACT_APP_RMP_APP_ID,
        }),
      );
    }
  }, [businessInfoResult, setBusinessAdwordsIdResult]);

  useEffect(() => {
    if (businessInfoResult.data.business_id && accountDataResult.result !== 0) {
      getAccountData();
    }
  }, [businessInfoResult]);

  const getAccountData = async () => {
    await dispatch(
      googleActions.getAccountData({
        token: rmpToken,
        business_id: businessInfoResult.data.business_id,
        agency_id: businessInfoResult.data.agency_id,
        adwords_id: businessInfoResult.data.adwords_id,
      }),
    );
  };

  const handleEditButton = () => {
    dispatch(googleActions.changeSettingPage("signin"));
  };

  const view = () => {
    return (
      <>
        <SetupTextHeader>{t("__ads_setup_title")}</SetupTextHeader>

        <Row alignItems="stretch">
          <ConnectedAdsContainer>
            <ConnectedAdsColumn1>
              <div className="secondary-text">{t("__ads_connected_account_name")}</div>
              <div>
                {businessInfoResult.data.adwords_name &&
                businessInfoResult.data.adwords_name !== "" &&
                businessInfoResult.data.adwords_name !== "-"
                  ? businessInfoResult.data.adwords_name
                  : t("__ads_label_google_ads_account")}
              </div>
              <div>{businessInfoResult.data.adwords_id}</div>
            </ConnectedAdsColumn1>
            <ConnectedAdsColumn2>
              <div className="secondary-text">{t("__ads_connected_account_status")}</div>
              <div className={accountDataResult.adwords_id ? "text-green" : "text-red"}>
                {accountDataResult.adwords_id
                  ? t("__ads_connected_account_connected")
                  : t("__ads_connected_account_not_connected")}
              </div>
            </ConnectedAdsColumn2>
            <ConnectedAdsColumn3>
              <Button type="secondary" onClick={handleEditButton} loading={loading} round>
                {t("__ads_connected_account_edit")}
              </Button>
            </ConnectedAdsColumn3>
          </ConnectedAdsContainer>
        </Row>
      </>
    );
  };

  return view();
};

export default Connected;

const ContainerMobile = styled(Section)`
  margin: 0 40px 24px !important;
  & > .row {
    justify-content: space-evenly;
  }
`;

const SetupTextHeader = styled(TextHeader)`
  font-size: 18px;
  margin-bottom: 10px;
`;

const ConnectedAdsContainer = styled.div`
  display: flex;
  width: 100%;
  font-size: 14px;

  .text-green {
    color: #4caf50;
  }

  .text-red {
    color: #f44336;
  }

  .secondary-text {
    color: #aaa;
    font-size: 12px;
  }
`;

const ConnectedAdsColumn1 = styled.div`
  flex-grow: 1;
`;

const ConnectedAdsColumn2 = styled.div`
  flex-grow: 1;
  white-space: nowrap;
  padding: 0px 20px;
`;

const ConnectedAdsColumn3 = styled.div`
  flex-shrink: 1;
`;
